export default {
  menuTitle: '数据看板',
  pageTitle: '数据看板',
  businessTimezone: '业务时区：{timezone}',
  generatedAt: '数据更新时间：{time}',
  refresh: '刷新数据',
  period: '统计周期',
  periodToday: '今日',
  periodMonth: '本月至今',
  periodAll: '全部',
  coreMetrics: '核心指标',
  shareCount: '商品被分享次数',
  orders: '分佣产品订单',
  actualSales: '实际销售额',
  commissionSpend: '分佣支出',
  previousDay: '昨日',
  previousMonth: '上月同期',
  previousPeriodValue: '{period}：{value}',
  trend: '近30日趋势',
  metricGmv: '销售额',
  metricCommission: '佣金',
  metricShares: '分享',
  metricClicks: '点击',
  metricOrders: '订单',
  metricCount: '数量',
  trendPendingExternal: '{metrics}部分日期的数据待接入，趋势中暂不按 0 展示。',
  funnel: '转化漏斗（本月）',
  funnelExposure: 'Affiliate商品曝光',
  funnelClicks: '点击进商详',
  funnelShares: '分享',
  funnelOrders: '下单',
  funnelSigned: '签收',
  rankings: '分佣产品销售榜 TOP5（历史累计）',
  ranking: '排名',
  product: '商品',
  cpsSalesQuantity: 'Affiliate销量',
  commissionRate: '佣金率',
  commission: '总佣金',
  gmv: '总销售额',
  unavailableProduct: '商品信息暂不可用',
  listingId: 'Listing ID：{id}',
  pendingExternal: '数据待接入',
  partialInternal: '部分数据暂不可用',
  rankingPartial: '排行榜包含当前可证明的数据，另有 {count} 条记录因数据不完整未纳入。',
  noData: '暂无数据',
  loadFailed: 'Affiliate数据看板加载失败',
  unknownError: '请求失败，请稍后重试'
}
